export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_11-7f3415cf5287d6252f70038b265cc8d4.jpg";